<div class="body">
    <div id="contentbody">
        <img src="./assets/png/BlancoSVG.svg" class="logoRadio">

        <img src="./assets/png/LogoATT2.png" class="imglogoAtt">
    </div>
    <div class="section1">
        <div class="contentradios">
            <div>
                <app-radio-online></app-radio-online>
            </div>
        </div>

        <div class="streaming-cont">
            <p class="titleStreaming pt-4 mt-3">STREAMING</p>
            <div class="iframe-cont embed-responsive embed-responsive-16by9">
                <iframe src="//www.alsolnet.com/stream/grupocentrobo/player.htm" scrolling="no" frameborder="0"
                    allowfullscreen="true" allow="autoplay" webkitallowfullscreen="true" mozallowfullscreen="true"
                    class="embed-responsive-item">
                </iframe>
            </div>
        </div>
    </div>

    <mat-divider class="matDivider mt-3"></mat-divider>
    <div class="trianguloPadre">
        <div class="triangle-down"></div>
    </div>

    <div class="section2 pt-3">
        <div class="news-cont">
            <p class="titleStreaming pt-3">NOTICIAS</p>
            <p class="contenttext">
                Toda la información que necesitas en un solo portal
            </p>
        </div>

        <div class="category-slides">
            <p class="titleStreaming pt-2">CATEGORIAS</p>
            <app-category-slides [categorias]="categorias | async"  (openCategorySel)="openCategory($event.name)"></app-category-slides>
        </div>

        <mat-divider class="matDivider"></mat-divider>
        <div class="trianguloPadre">
            <div class="triangle-down"></div>
        </div>
    </div>

    <div class="recent pt-3">
        <p class="titleStreaming pt-3">LO MÁS RECIENTE</p>
        <div class="recent-row row" *ngIf="!mobileQuery.matches">
            <div class="recent-new col-4" *ngFor="let news of newss">
                <mat-card class="new-card">
                    <img mat-card-image height="250px" [src]="news.image" [alt]="news.title">
                    <mat-card-content class="card-content">
                        <p class="newstext">{{news.autor | truncate: "60"}}</p>
                        <h4>
                            {{news.description|truncate:"250"}}
                        </h4>
                    </mat-card-content>
                    <mat-card-actions align="middle">
                        <button (click)="openNews(news.id)" mat-stroked-button color="warn">
                            VER MAS
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>

        <div class="recent-slides" *ngIf="mobileQuery.matches">
            <app-recent-slides [newss]="newsOberserver"></app-recent-slides>
        </div>

        <button class="go-news" mat-raised-button color="warn" routerLink="/noticias">
            IR A NOTICIAS
        </button>
    </div>

    <mat-divider class="matDivider mt-5"></mat-divider>
    <div class="trianguloPadre">
        <div class="triangle-down"></div>
    </div>

    <div class="live-container" *ngIf='actualPlaynig'>
        <div class="row m-0">
            <div class="col-lg-6">
                <div class="img-portada">
                    <img *ngIf='!radioProgram' [src]="actualPlaynig.image" [alt]="actualPlaynig.name">
                    <img *ngIf='radioProgram' [src]="radioProgram.image" [alt]="actualPlaynig.name">
                    <div class="media-actions">
                        <p style="text-align: center;">{{actualPlaynig.name}}</p>
                        <div>
                            <div>
                                <button mat-button (click)="pause()" *ngIf="radiosDataService.PLAYLISTONOFF">
                                    <mat-icon [ngStyle]="{'color':'black'}">pause</mat-icon>
                                </button>
                                <button mat-button *ngIf="!radiosDataService.PLAYLISTONOFF"
                                    (click)="verifyRadioToPlay()">
                                    <mat-icon [ngStyle]="{'color':'black'}">play_arrow</mat-icon>
                                </button>
                                <button mat-button [matMenuTriggerFor]="menu">
                                    <mat-icon [ngStyle]="{'color':'black'}">volume_up</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <mat-slider vertical='false' [(ngModel)]="value" #mySlider
                                        (slideend)="sliderOnChange(mySlider.value)"
                                        (pointerup)="sliderOnChange(mySlider.value)"></mat-slider>
                                </mat-menu>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{texto}}
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" *ngIf='radios'>
                        <button class="dropdown-item" (click)="verifyRadioOption('fm96.1')">{{radios[2].name}}</button>
                        <button class="dropdown-item" (click)="verifyRadioOption('universal')">
                            {{radios[0].name}}</button>
                        <button class="dropdown-item" (click)="verifyRadioOption('am24.7')">{{radios[1].name}}</button>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 radio-text">
                <div class="hra-portada">
                    <p>EN VIVO / {{dateactuall | date:'HH:mm:ss a'}}</p>
                </div>
                <div class="descripcion-portada" *ngIf='radioProgram'>
                    <p>{{radioProgram.name}}</p>
                    <h4>{{radioProgram.description|truncate:"400"}}</h4>
                </div>
                <div class="descripcion-portada" *ngIf='!radioProgram'>
                    <p>Sin Programa</p>
                    <h4>Estamos con contenido fuera de programa</h4>
                </div>
            </div>
        </div>
    </div>

    <div class="publicidad">
        <div class="contenedor-publicidad">
            <div class="contenedor-texto-publicidad">
                <app-publicidad></app-publicidad>
            </div>
        </div>
    </div>

    <footer>
        <app-footer-new></app-footer-new>
    </footer>
</div>
